import ConfirmationModal from '@/pages/components/ConfirmationModal'

export const ModalConfirmation = {
  data () {
    return {
      modal_confirmation_data: {
        title: '',
        message: '',
        label: '',
        show: false
      }
    }
  },
  components: {
    ConfirmationModal
  },
  methods: {
    getModalConfirmation (title, message, label, data = null) {
      this.modal_confirmation_data = {
        title: title,
        message: message,
        label: label,
        show: true,
        data: data
      }
      // this.modal_confirmation_data.title = title
      // this.modal_confirmation_data.message = message
      // this.modal_confirmation_data.label = label
      // this.modal_confirmation_data.show = true
    },
    clearModalConfirmationData () {
      this.modal_confirmation_data = {
        title: '',
        message: '',
        label: '',
        show: false
      }
      // this.modal_confirmation_data.title = ''
      // this.modal_confirmation_data.message = ''
      // this.modal_confirmation_data.label = ''
      // this.modal_confirmation_data.show = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/library/mixins/local/ModalConfirmation.js